import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_LOCATION_TYPE_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateLocationTypeImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_LOCATION_TYPE_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateLocationTypeImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.locationTypes.locationType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_LOCATION_TYPE_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateLocationTypeImageDetailsArgs(data) },
        dispatch,
        UPDATE_LOCATION_TYPE_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateLocationTypeImageDetailsMutation
